import { Vehicle } from '../systems/vehicle.js';

/**
 * 车上的那块仪表：速度、油表、车况。
 * 不在车上就整个藏起来，免得占着画面。
 */
export class Dashboard {
  constructor(engine) {
    this.engine = engine;
    this.el = {
      root: document.getElementById('dash'),
      name: document.getElementById('dash-name'),
      speed: document.getElementById('dash-speed'),
      fuelBar: document.getElementById('dash-fuel-bar'),
      fuelTxt: document.getElementById('dash-fuel'),
      durBar: document.getElementById('dash-dur-bar'),
      durTxt: document.getElementById('dash-dur'),
      state: document.getElementById('dash-state'),
    };
    this._acc = 0;
    if (!this.el.root) return;
  }

  update(dt) {
    if (!this.el.root) return;
    this._acc += dt;
    if (this._acc < 0.12) return;
    this._acc = 0;

    const s = Vehicle.state;
    if (!s || !s.driving) {
      this.el.root.classList.add('hidden');
      return;
    }
    this.el.root.classList.remove('hidden');

    const fuelPct = Math.max(0, Math.min(1, s.fuel / Math.max(1, s.maxFuel)));
    const durPct = Math.max(0, Math.min(1, s.dur / Math.max(1, s.maxDur)));
    this.el.name.textContent = s.name || '车';
    this.el.speed.textContent = `${Math.round(s.speed / 6)}`;   // 像素/秒 大约换算成「里/时」的观感
    if (this.el.fuelBar) this.el.fuelBar.style.width = `${fuelPct * 100}%`;
    if (this.el.durBar) this.el.durBar.style.width = `${durPct * 100}%`;
    if (this.el.fuelTxt) this.el.fuelTxt.textContent = `${Math.round(fuelPct * 100)}%`;
    if (this.el.durTxt) this.el.durTxt.textContent = `${Math.round(durPct * 100)}%`;

    let note = '';
    if (s.broken) note = '趴窝了，只能推';
    else if (s.outOfFuel) note = '没油了';
    else if (durPct < 0.2) note = '到处响';
    else if (fuelPct < 0.2) note = '油不多了';
    if (this.el.state) {
      this.el.state.textContent = note;
      this.el.state.style.display = note ? '' : 'none';
    }
  }
}
